import type { Source } from "@tandemdiabetes/sugarmate-api-react-client"
import { useSaveSource } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"

import { useSources } from "./useSources"
import type { PartialWithId } from "src/types"
import { noticeError } from "src/utils"

export function useUpdateSource() {
  const saveSource = useSaveSource()
  const { mutate } = useSources()

  const updateSource = useMemo(
    () => saveSource && (async (source: PartialWithId<Source>) => {
      try {
        const response = await saveSource(source)

        void mutate([response.data.source])
        return response
      } catch (e) {
        noticeError(
          e,
          "UpdateSource",
          { source },
        )

        throw e
      }
    }),
    [
      saveSource,
      mutate,
    ],
  )

  return updateSource
}
